export default {
  title: 'Ny variant',
  fields: {
    product: {
      label: 'Produkt',
    },
    name: {
      label: 'Navn',
      placeholder: 'Stor',
    },
    price: {
      label: 'Ekstra pris',
    },
  },
  buttons: {
    save: 'Gem',
    close: 'Luk',
  },
  toasts: {
    variant_got_created: 'Varianten blev oprettet',
    variant_got_updated: 'Varianten blev opdateret',
  },
};
